import { Directive, Input } from '@angular/core';

@Directive({ selector: 'app-change-log-link-entity' })
export class ChangeLogLinkEntityDirective {

  constructor() { }

  @Input() type = '';
  @Input() id = '';
  @Input() includeChildren = true;
  @Input() includeGrandChildren = false;
}
